import React from 'react';

/**
 * Button: primary, secondary, ghost, destructive.
 * Use primary for main CTAs; accent color for key actions.
 */
export function Button({
  children,
  variant = 'secondary',
  size = 'md',
  disabled = false,
  type = 'button',
  onClick,
  className = '',
  icon: Icon,
  ...props
}) {
  const classes = ['ui-btn', `ui-btn--${variant}`, `ui-btn--${size}`, className].filter(Boolean).join(' ');
  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {Icon && <Icon className="ui-btn__icon" size={size === 'sm' ? 16 : 20} />}
      {children}
    </button>
  );
}
